import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLText} from '@github-ui/safe-html/VerifiedHTML'
import {clsx} from 'clsx'

import styles from './SearchMatchText.module.css'

type SearchMatchTextProps = {
  /**
   * An escaped HTML string with an <em> around the matching substring.
   */
  text: SafeHTMLString

  /**
   * Optional prop to pass into the text component for fontWeight.
   */
  fontWeight?: string

  className?: string
}

export default function SearchMatchText({text, fontWeight, className}: SearchMatchTextProps) {
  return (
    <VerifiedHTMLText
      className={clsx('search-match', styles.searchMatchText, className)}
      html={text}
      style={fontWeight ? {fontWeight} : undefined}
    />
  )
}
